<template>
  <div v-title data-title="注册成功" class="regthirddissuccess">
    <div class="bg-white">
      <div class="succeed">
        <img src="../../assets/img/zc-succeed.jpg" />
        <p class="fc-orange">恭喜你！</p>
        <p>你已经成为壹选生活家游客成员！</p>
        <p>快去分享产品给你的好友吧</p>
        <a href="javascript:void(0)" class="btn-fx" @click="toHome()">立即分享</a>
      </div>
      <div class="rm-t">
        <span>家游站热卖产品</span>
      </div>

      <div class="weui-flex rmcp">
        <div
          class="weui-flex__item"
          @click="ProductDetail(formset[0].Guid)"
          v-if="formset.length>=1"
        >
          <img v-lazy="formset[0].ProductImgUrl" class="lazy-img-fadein" />
          <a href="javascript:void(0)">{{formset[0].ProductName}}</a>
          <p class="fc-red">
            ￥
            <i>{{formset[0].SatrtAmount}}</i>
            <span>赚￥{{formset[0].Commission}}</span>
          </p>
        </div>
        <div
          class="weui-flex__item"
          @click="ProductDetail(formset[1].Guid)"
          v-if="formset.length>=2"
        >
          <img v-lazy="formset[1].ProductImgUrl" class="lazy-img-fadein" />
          <a href="javascript:void(0)">{{formset[1].ProductName}}</a>
          <p class="fc-red">
            ￥
            <i>{{formset[1].SatrtAmount}}</i>
            <span>赚￥{{formset[1].Commission}}</span>
          </p>
        </div>
      </div>
      <div class="weui-flex rmcp">
        <div
          class="weui-flex__item"
          @click="ProductDetail(formset[2].Guid)"
          v-if="formset.length>=3"
        >
          <img v-lazy="formset[2].ProductImgUrl" class="lazy-img-fadein" />
          <a href="javascript:void(0)">{{formset[2].ProductName}}</a>
          <p class="fc-red">
            ￥
            <i>{{formset[2].SatrtAmount}}</i>
            <span>赚￥{{formset[2].Commission}}</span>
          </p>
        </div>
        <div
          class="weui-flex__item"
          @click="ProductDetail(formset[3].Guid)"
          v-if="formset.length>=4"
        >
          <img v-lazy="formset[3].ProductImgUrl" class="lazy-img-fadein" />
          <a href="javascript:void(0)">{{formset[3].ProductName}}</a>
          <p class="fc-red">
            ￥
            <i>{{formset[3].SatrtAmount}}</i>
            <span>赚￥{{formset[3].Commission}}</span>
          </p>
        </div>
      </div>
      <wv-popup :visible.sync="showguidethepublic" height="100%">
        <scroller style="position:fixed;top:0;text-align:center;">
          <img v-bind:src="guidethepublic" style="width:70%; margin-top:20px;" />
          <div style="text-align:center;" @click="showguidethepublic=false">
            <i data-v-460a00e2 class="weui-icon-cancel"></i>
          </div>
        </scroller>
      </wv-popup>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import guidethepublic from "../../assets/img/guidethepublic.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "regthirddissuccess",
  data: function() {
    return {
      LoginType: -1,
      formset: [],
      TotalCount: 0,
      disid: "",
      showguidethepublic: false,
      guidethepublic: guidethepublic,
      isSubscribe: ""
    };
  },
  computed: {},
  created: function() {
    this.isSubscribe = this.$route.query.isSubscribe;
    this.InitProduct();
  },
  mounted: function() {
    if (this.isSubscribe == 0) {
      this.showguidethepublic = true;
    }
  },
  methods: {
    InitProduct: function(type) {
      var data = {
        ProductName: "",
        IsOrderByPriceAsc: null,
        ProductTypes: [],
        ScenicareaId: null,
        HoltelId: null,
        PageSize: 4,
        PageNum: 1,
        LoginType: -1
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tbproduct/productpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.formset = rep.Data.List;
            this.disid = rep.Data.DisGuid;
            var i = 0;
            for (; i < this.formset.length; i++) {
              if (this.formset[i].ProductName.length > 20) {
                this.formset[i].ProductName =
                  this.formset[i].ProductName.substring(0, 20) + "...";
              }
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    toHome() {
      this.$router.push("/app/home");
    },
    //产品详情
    ProductDetail: function(orderGuid) {
      if (this.LoginType == 4) {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
            disid: this.disid
          }
        });
      } else {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid
          }
        });
      }
    }
  }
};
</script>




<style>
.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left {
  width: 50%;
  text-align: center;
  float: left;
  background-color: #fff;
}

.weui-cells {
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.needtomargin-top-wx {
  padding-top: 40px;
}
.needtomargin-top-common {
  padding-top: 90px;
}
.regthirddissuccess .wv-popup[data-v-f3183a8e] {
  background-color: initial !important;
}
</style>




// WEBPACK FOOTER //
// src/components/fun/regthirddissuccess.vue